/**
 * Shared utilities.
 *
 * `cn` is the idiomatic Tailwind class merger used across shadcn/ui.
 */

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
